import { bankDisplayName } from './kgsBanks';
import { settlementExportFields, providerSettlementExportFields } from './settlementExport';

export const formatAmount = (value?: number | null, currency?: string | null, maximumFractionDigits = 2) => {
    if (typeof value !== 'number' || !Number.isFinite(value)) return '-';
    const formatted = value.toLocaleString('ru-RU', { maximumFractionDigits });
    if (currency === 'RUB') return `${formatted} ₽`;
    return `${formatted} ${currency || ''}`.trim();
};

export const parseUTCDate = (value?: string | null) => {
    if (!value) return null;
    const normalized = /[zZ]|[+-]\d{2}:?\d{2}$/.test(value) ? value : `${value}Z`;
    const date = new Date(normalized);
    return Number.isNaN(date.getTime()) ? null : date;
};

export const formatUTCDateTime = (value?: string | null) => {
    const date = parseUTCDate(value);
    if (!date) return '-';

    return `${date.toLocaleString('ru-RU', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: 'UTC',
    })} UTC+0`;
};

export const getMerchantTransactionId = (tx: any) => (
    tx.typical_order_id || tx.merchantPaymentId || tx.merchantWithdrawalId || tx.payment_id || '-'
);

export const getTransactionRequisiteType = (tx: any) => {
    const fiatCurrency = String(tx.fiat_currency || tx.currency || '').toUpperCase();
    if (fiatCurrency === 'KGS' && tx.requisite_type === 'sbp') return 'sbp_kgs';
    return tx.requisite_type || 'Не указан';
};

export const formatRequisites = (
    requisites?: Record<string, any> | null,
    fiatCurrency?: string | null,
) => {
    if (!requisites || Object.keys(requisites).length === 0) return 'Не указаны';
    const parts = [
        bankDisplayName(requisites.recipient_bank),
        requisites.recipient_name,
        requisites.recipient_card,
        requisites.phone_number,
        typeof requisites.transfer_amount === 'number'
            ? formatAmount(requisites.transfer_amount, fiatCurrency)
            : requisites.transfer_amount
                ? `${requisites.transfer_amount} ${fiatCurrency || ''}`.trim()
                : null,
    ].filter(Boolean);
    return parts.length ? parts.join(' · ') : 'Не указаны';
};

export const adminTransactionExportRow = (tx: any) => ({
    'Мерчант': tx.merchant_username || tx.merchant_name || '',
    'Тип операции': tx.order_type === 'deposit' ? 'Депозит' : tx.order_type === 'withdraw' ? 'Вывод' : '',
    'ID наш': tx.transaction_id || '',
    'ID мерчанта': getMerchantTransactionId(tx),
    'Customer ID': tx.customer_id == null ? 'Не передан' : String(tx.customer_id),
    'Тип трафика': tx.traffic_type?.toUpperCase() || 'Не передан',
    'Дата создания ордера': formatUTCDateTime(tx.created_at),
    'Дата финализации': formatUTCDateTime(tx.closed_at || tx.completed_at || tx.cancelled_at),
    'Метод': getTransactionRequisiteType(tx),
    'Сумма fiat': tx.amount_fiat ?? tx.amount ?? '',
    'Fiat валюта': tx.fiat_currency || tx.currency || '',
    'Сумма USDT': tx.amount_usdt ?? '',
    'Статус': tx.status || '',
    ...settlementExportFields(tx),
    ...providerSettlementExportFields(tx),
    'Провайдер': tx.provider_name || '',
    'ID провайдера': tx.provider_id || '',
    'Order ID провайдера': tx.external_order_id || '',
    'ID настройки провайдера': tx.external_platform_id || '',
    'Данные реквизита': formatRequisites(
        tx.requisites,
        tx.fiat_currency || tx.currency,
    ),
});

export const adminTransactionExportColumns = [
    { wch: 24 },
    { wch: 16 },
    { wch: 28 },
    { wch: 24 },
    { wch: 28 },
    { wch: 16 },
    { wch: 24 },
    { wch: 24 },
    { wch: 22 },
    { wch: 14 },
    { wch: 12 },
    { wch: 14 },
    { wch: 18 },
    { wch: 20 },
    { wch: 28 },
    { wch: 32 },
    { wch: 28 },
    { wch: 46 },
];
adminTransactionExportColumns.splice(12, 0, { wch: 18 }, { wch: 66 }, { wch: 18 }, { wch: 66 });
